// PostOpHealingSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import postOpHealingImage from '../assets/post-op-healing-image.jpg';

const PostOpHealingSection = () => {
  return (
    <section className="py-16 md:py-24 bg-bnCream">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div>
            <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Recovery At Home
            </p>
            <h2 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Post-Operative Care that Promotes Healing and Peace of Mind
            </h2>

            <div className="space-y-4 text-bnBody text-base leading-relaxed mb-10">
              <p>
                At B & N Enterprise, our post-operative care is designed to help people recover safely and comfortably at home following surgery. We understand that the days after a medical procedure can be both physically demanding and emotionally overwhelming, which is why our carers provide attentive, reassuring support every step of the way. From medication reminders to mobility assistance, we help you or your loved one regain strength and confidence while minimising stress.
              </p>

              <p>
                Our carers focus on creating a calm, structured recovery environment that allows healing to progress smoothly. We offer help with daily routines, meal preparation, personal hygiene, and follow-up appointments, making sure nothing is overlooked during this important period. Each visit is guided by empathy and professionalism, giving families peace of mind knowing that their loved one is recovering under caring, watchful support.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-bnAccent hover:bg-bnAccentDark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={18} />
              Call: +61 480 804 640
            </a>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src={postOpHealingImage}
              alt="A carer assisting an older woman using a walking frame"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PostOpHealingSection;
